import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { ClientCompanyModel } from 'src/Models/ClientCompanyModel';
import { AdminUserType } from 'src/Models/Common';
import { BriefingReportFilterModelV2, BriefingReportModel } from 'src/Models/ReportModel';
import { ReportService } from 'src/Services/report.service';
import { CheckAuth } from 'src/Services/utility.service';
import { UpdatesService } from 'src/Services/updatesService';
import * as FileSaver from 'file-saver';
import { AllActiveBriefingsByCompanyModel } from 'src/Models/MonthlySummaryofDeliveredBriefingsByCompanyModel';
import { I360Service } from 'src/Services/i360Service';
import { StateMasterService } from 'src/Services/state-master.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-company-subscription-reports',
  templateUrl: './company-subscription-reports.component.html',
  styleUrls: ['./company-subscription-reports.component.css']
})
export class CompanySubscriptionReportsComponent implements OnInit {

  tokenKey: string = '';
  filterModel = new BriefingReportFilterModelV2();
  clientCompanyList = new Array<ClientCompanyModel>();
  selectedCompany: any;
  dropdownSettingsCompany = {};

  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  listOfStateIds = [];

  dropdownListBriefingTypes = [];
  selectedItemsBriefingTypes = [];
  dropdownSettingsBriefingTypes = {};
  listOfBriefingTypesIds = [];

  loginuserID: any;
  isloading = false;
  SelectedTool = '';
  systemUserCondition: string = '';

  listOfData: AllActiveBriefingsByCompanyModel[];
  listOfExportData: AllActiveBriefingsByCompanyModel[];

  currentPage: number = 1;
  productId: number = 7;

  totalRecordCount: number = -1;

  isAscending: boolean = false
  upDowCompanynameCSS: string = '';
  upDowDemoCSS: string = '';
  upDowCompCSS: string = '';
  upDowSFaccountCSS: string = '';

  constructor(private readonly checkAuth: CheckAuth, 
    private readonly titleService: Title,
    private readonly reportService: ReportService, 
    private readonly updatesService: UpdatesService,
    private readonly toastrService: ToastrService,
    private readonly i360service: I360Service,
    private readonly stateMasterService: StateMasterService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.loginuserID = this.sessionStorageService.getAdminUserId();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('All Active Companies Report');
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    if (AdminUserType.systemadmin == this.sessionStorageService.getAdminTypeId())
      this.systemUserCondition = 'null'
    else
      this.systemUserCondition = '  (CompanyId IN (Select CompanyId From [SystemUserCompany] Where [SystemUserCompany].UserId = ' + this.loginuserID + '))';

      this.filterModel.orderBy='CompanyName';
      this.filterModel.pageNumber = '1';
      this.filterModel.pageSize = '10';
  }

  ngOnInit() {
    this.loadDropdownSettings();
    this.movetotop();
    this.GetClientCompany();
    this.getAllActiveBriefingSubscrittionCompany();
    this.GetBulletinTypeData();
    this.GetStateData();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  getAllActiveBriefingSubscrittionCompany() {
    this.listOfData = [];
    this.isloading = true;
    this.filterModel.isExport=false;
    this.reportService.AllActiveBriefingCompanySubscription(this.tokenKey, this.filterModel).subscribe(data => {
      this.isloading = false;
      if (data) {
        if (data.status == "Success") {
          this.listOfData = data.lstReport;

          if(this.listOfData.length>0){
              this.totalRecordCount = data.lstReport[0].totalRecord;
          }
          else{
            this.totalRecordCount = 0;
          }
        }
        else {
          this.totalRecordCount = 0;
          this.toastrService.error("Error", "error");
        }
      }
    }, error => {
      this.isloading = false;
    })
  }

  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

  GetClientCompany() {
    this.clientCompanyList = [];
    this.updatesService.GetClientCompany(this.tokenKey, 7, this.systemUserCondition).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.clientCompanyList = data['clientCompanay'];
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  transformDate(array) {
    if (array != null) {

      let dd = array.getDate().toString();
      if (parseInt(dd.toString()) < 10)
        dd = '0' + dd.toString();

      let mm = (array.getMonth() + 1).toString();
      if (parseInt(mm.toString()) < 10)
        mm = '0' + mm.toString();

      let hrs = array.getHours();
      if (parseInt(hrs.toString()) < 10)
        hrs = '0' + hrs.toString();

      let min = array.getMinutes()
      if (parseInt(min.toString()) < 10)
        min = '0' + min.toString();

      let sec = array.getSeconds()
      if (parseInt(sec.toString()) < 10)
        sec = '0' + sec.toString();

      return array.getFullYear() + '_' + mm + '_' + dd + '_' + hrs + '_' + min + '_' + sec;
    }
  }

  loadDropdownSettings() {
    this.dropdownSettingsCompany = {
      singleSelection: true,
      text: "Select Company",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 2,
      noDataLabel: 'No data available for selected company',
      showCheckbox: false,
      primaryKey: 'companyId',
      labelKey: 'companyName',
      enableCheckAll: false,
      enableFilterSelectAll: false,
    };
  }

  onSelectState($event) {
    this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
    this.listOfStateIds.push($event.id);
    this.filterModel.stateID = this.listOfStateIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  onDeSelectState($event) {
    if (this.listOfStateIds != null) {
      if (this.listOfStateIds.length > 0) {
        this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
      }
    }
    this.filterModel.stateID = this.listOfStateIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  onSelectAllState($event) {
     for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
          this.listOfStateIds.push(item.id);
        }
        else {
          this.listOfStateIds.push(item.id);
        }
      }
    }
    this.filterModel.stateID = this.listOfStateIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  onDeSelectAllState($event) {
    this.listOfStateIds = [];
    this.filterModel.stateID = null;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  GetStateData(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.stateMasterService.getStateV2(this.tokenKey, this.productId).subscribe(
      data => {
        if (data["state"] != null) {
          for (let iCounter = 0; iCounter < data["state"].length; iCounter++) {
            this.dropdownListState.push(
              { "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name }
            );
          }
        }
        this.dropdownSettingsState = {
          singleSelection: false,
          text: "Select Jurisdiction(s)",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 1,
          noDataLabel: 'No Jurisdiction available',
          showCheckbox: true
        };
      }, error => {
        console.log(error);
      })
  }

  GetBulletinTypeData(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.i360service.i360BulletinTypeGet(this.tokenKey).subscribe(
      data => {
        if (data["listOfBulletinType"] != null) {
          for (let iCounter = 0; iCounter < data["listOfBulletinType"].length; iCounter++) {
            this.dropdownListBriefingTypes.push(
              { "id": data["listOfBulletinType"][iCounter].carrierCatId, "itemName": data["listOfBulletinType"][iCounter].carrierCatName }
            );
          }
        }

        this.dropdownSettingsBriefingTypes = {
          singleSelection: false,
          text: "Select Briefing Types",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 1,
          noDataLabel: 'No briefing types available',
          showCheckbox: true
        };
      }, error => {
        console.log(error);
      })
  }

  onSelectBriefingTypes($event) {
    this.listOfBriefingTypesIds = this.removeElemetninArray(this.listOfBriefingTypesIds, $event.id)
    this.listOfBriefingTypesIds.push($event.id);
    this.filterModel.BriefingTypesId = this.listOfBriefingTypesIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  onDeSelectBriefingTypes($event) {
    if (this.listOfBriefingTypesIds != null) {
      if (this.listOfBriefingTypesIds.length > 0) {
        this.listOfBriefingTypesIds = this.removeElemetninArray(this.listOfBriefingTypesIds, $event.id)
      }
    }
    this.filterModel.BriefingTypesId = this.listOfBriefingTypesIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  onSelectAllBriefingTypes($event) {
     for (const item of $event) {
      if (this.listOfBriefingTypesIds != null) {
        if (this.listOfBriefingTypesIds.length > 0) {
          this.listOfBriefingTypesIds = this.removeElemetninArray(this.listOfBriefingTypesIds, item.id)
          this.listOfBriefingTypesIds.push(item.id);
        }
        else {
          this.listOfBriefingTypesIds.push(item.id);
        }
      }
    }
    this.filterModel.BriefingTypesId = this.listOfBriefingTypesIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  onDeSelectAllBriefingTypes($event) {
    this.listOfBriefingTypesIds = [];
    this.filterModel.BriefingTypesId = null;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  onFilterSelectAllBriefingTypes($event) {
     for (const item of $event) {
      if (this.listOfBriefingTypesIds != null) {
        if (this.listOfBriefingTypesIds.length > 0) {
          this.listOfBriefingTypesIds = this.removeElemetninArray(this.listOfBriefingTypesIds, item.id)
          this.listOfBriefingTypesIds.push(item.id);
        }
        else {
          this.listOfBriefingTypesIds.push(item.id);
        }
      }
    }
    this.filterModel.BriefingTypesId = this.listOfBriefingTypesIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  onFilterDeSelectAllBriefingTypes($event) {
     for (const item of $event) {
      if (this.listOfBriefingTypesIds != null) {
        if (this.listOfBriefingTypesIds.length > 0) {
          this.listOfBriefingTypesIds = this.removeElemetninArray(this.listOfBriefingTypesIds, item.id)
        }
      }
    }
    this.filterModel.BriefingTypesId = this.listOfBriefingTypesIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  onFilterSelectAllState($event) {
     for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
          this.listOfStateIds.push(item.id);
        }
        else {
          this.listOfStateIds.push(item.id);
        }
      }
    }
    this.filterModel.stateID = this.listOfStateIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  onFilterDeSelectAllState($event) {
     for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
        }
      }
    }
    this.filterModel.stateID = this.listOfStateIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  onCompanySelect(selectedCompany) {
    this.filterModel.companyId = 0;
    if (this.selectedCompany.length > 0 && selectedCompany.length != 0) {
      this.filterModel.companyId = this.selectedCompany[0].companyId;
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.pageNumber = parseInt($event.page).toString();
    this.getAllActiveBriefingSubscrittionCompany();
  }

  sort(sortBy: any) {
    this.upDowCompanynameCSS = '';
    this.upDowDemoCSS = '';
    this.upDowCompCSS = '';
    this.upDowSFaccountCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "CompanyName") {
        this.upDowCompanynameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "IsDemo") {
        this.upDowDemoCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "IsComp") {
        this.upDowCompCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "SFAccount") {
        this.upDowSFaccountCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === "CompanyName") {
        this.upDowCompanynameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "IsDemo") {
        this.upDowDemoCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "IsComp") {
        this.upDowCompCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "SFAccount") {
        this.upDowSFaccountCSS = 'fa fa-arrow-up';
      }
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getAllActiveBriefingSubscrittionCompany();
  }

  getAllActiveBriefingSubscrittionCompanyExport() {
    this.listOfExportData = [];
    this.isloading = true;
    this.filterModel.isExport=true;
    this.reportService.AllActiveBriefingCompanySubscription(this.tokenKey, this.filterModel).subscribe(data => {
      this.isloading = false;
      if (data) {
        if (data.status == "Success") {
          this.listOfExportData = data.lstReport;
          setTimeout(() => {
          if (this.listOfExportData.length > 0) {
            var uri = 'data:application/vnd.ms-excel;base64,'
              , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
              , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
              , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
            let html = '<table>';
            if (this.filterModel.companyId && this.selectedCompany) {
              html += "</tr><tr class='mainhead'>    <td colspan='3'> Company: " + this.selectedCompany[0].companyName + "</td>  </tr>";
            }
            html += document.getElementById("reportHeader").innerHTML + " " + document.getElementById("reportBody").innerHTML;
            html += "</table>";
            var ctx = { worksheet: 'Worksheet', table: html }
            let dt = this.transformDate(new Date());
            FileSaver.saveAs((uri + base64(format(template, ctx))), "BriefingReportExport_" + dt + ".xls");
          }
          else {
            this.toastrService.error("No record found", "error");
          }
        }, 1000);

        }
        else {          
          this.toastrService.error("Error", "error");
        }
      }
    }, error => {
      this.isloading = false;
    })
  }


  exportToExcel() {
    this.getAllActiveBriefingSubscrittionCompanyExport();
  }
}
